import request from '../request';


//查询_订单统计
export const reqGetOrdersStats = (data) => request({ url:'/admin/stats/orders', method:'get', params:data });

//查询_营业额统计
export const reqGetTurnoverStats = (data) => request({ url:'/admin/stats/turnover', method:'get', params:data });

//查询_销量排名统计
export const reqGetRankingStats = (data) => request({ url:'/admin/stats/ranking', method:'get', params:data });
